import { getISOWeekWithYearFromDateString, isWeekWithYearInRange } from "../../utils/dates"

export default function isWeekValidForPermit(workPermitStart: string, workPermitEnd: string, year: number, week: number) {
    const startWeekWithYear = getISOWeekWithYearFromDateString(workPermitStart)
    const endWeekWithYear = getISOWeekWithYearFromDateString(workPermitEnd)
    if (!startWeekWithYear || !endWeekWithYear || !week || !year) return false
    return isWeekWithYearInRange(startWeekWithYear, endWeekWithYear, { week, year })
}
